'use client';

import { useTranslations } from 'next-intl';
import { usePwaInstall } from '@/components/features/pwa/PwaInstallProvider';
import NavigationItem from './NavigationItem';

interface Props {
  handleCloseSideBar: () => void;
}

export default function PwaInstallNavigationItem({ handleCloseSideBar }: Props) {
  const t = useTranslations('pwa');
  const { shouldShowSidebarInstallAction, startInstallFlow } = usePwaInstall();

  if (!shouldShowSidebarInstallAction) {
    return null;
  }

  const handleClick = () => {
    startInstallFlow();
    handleCloseSideBar();
  };

  return (
    <NavigationItem
      label={t('sidebar-install-action')}
      icon="download"
      onClick={handleClick}
      variant="account"
    />
  );
}
